module.exports = __webpack_public_path__ + "static/img/product-wrightinLuolan.035aa3c8.png";